export default __webpack_public_path__ + "static/media/auteuil3.38670b68.jpg";